<template>
  <!-- 人气排行 -->
  <div class="popularity">
    <ul>
      <li v-for="(item, index) in ranking" :key="item.id">
        <video
          :poster="$store.state.https + item.tp"
          @click="jump(item)"
          class="videss"
          :src="http + item.sp"
        ></video>
        <!-- <img src="../../../assets/cut.png" alt=""> -->
        <div class="message">
          <h4 @click="jump(item)">{{ item.name }}</h4>
          <p align="left" @click="jump(item)" v-html="item.kcjs"></p>
          <div class="price">
            <span class="price-now"> {{ item.jg }}</span>
            <div class="price-won">
              <i
                style="line-height: 20px; margin-right: 5px; color: #999999"
                class="iconfont gos-yanjing1"
              ></i>

              <div class="Thumb">浏览量：{{ item.ll }}</div>
            </div>
          </div>
          <div class="teacher" @click="eacherpage(item.userid)">
            <img :src="http + item.lstx" alt="" /> <span>{{ item.lsxm }}</span>
          </div>
        </div>
        <div class="ranking">
          <img v-if="index == 0" src="../../../assets/trophy1.png" alt="" />
          <img v-if="index == 1" src="../../../assets/Popularity2.png" alt="" />
          <img v-if="index == 2" src="../../../assets/Popularity3.png" alt="" />
          <div class="skkks" v-if="index > 2">{{ index + 1 }}</div>

          <div
            style="
              width: 92px;
              height: 32px;

              border-radius: 4px;
              margin-bottom: 10px;
            "
          ></div>
          <el-button
            @click="jump(item)"
            type="primary"
            style="
              width: 92px;
              height: 32px;

              border-radius: 4px;
            "
            >立即查看</el-button
          >
        </div>
      </li>
    </ul>
    <span class="viewmore" @click="viewmore()">查看更多</span>
    <div style="height: 60px"></div>
  </div>
</template>
<script>
import { selitem } from "../../../api/patient";

export default {
  data() {
    return {
      ranking: "",
      http: this.$store.state.https,
      sw: "",
      stpsde: {
        rows: 5,
      },
    };
  },
  mounted() {
    // this.$store.commit('getstate', '/ropularity')
  },
  created() {
    this.selitemif();
  },
  methods: {
    //   查看更多
    viewmore() {
      this.stpsde.rows = this.stpsde.rows + 5;

      this.selitemif();
      if (this.sw === this.ranking.length) {
        this.$message({
          showClose: true,
          message: "已加载全部",
        });
      }
    },
    //   跳转老师详情页
    eacherpage(item) {
      this.$router.push(`/TeacherDetailsPage/${item}`);
    },
    //   跳转视频详情页
    jump(item) {
      this.$router.push("/coursedetailspage");
      this.$store.commit("Jumpfordetails", item.id);
    },
    //   获取列表
    selitemif() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", this.stpsde.rows);
      data.append("px", "浏览倒");
      data.append("status", "已发布");
      selitem(data).then((res) => {
        this.ranking = res.rows;
        this.sw = res.total;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.popularity {
  ul {
    min-height: 750px;
    margin-bottom: 40px;
    background: #ffffff;
    li {
      display: flex;
      width: 772px;
      // height: 151px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      border-radius: 6px;
      margin-bottom: 8px;
      transition: all 0.2s;
      .message {
        display: flex;
        flex-direction: column;
        padding: 18px 0 12px 19px;
        h4 {
          white-space: nowrap;
          display: flex;
          justify-content: left;
          width: 237px;
          // height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-bottom: 4px;
          cursor: pointer;
        }
        p {
          cursor: pointer;
          width: 360px;
          height: 33px;
          font-size: 12px;
          font-family: "\5FAE\8F6F\96C5\9ED1";
          font-weight: 300;
          color: #999999;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 2; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
          margin-bottom: 9px;
        }
        .price {
          width: 360px;
          display: flex;
          justify-content: space-between;
          .price-now {
            width: 66px;
            text-align: left;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ff1616;
          }
        }
      }
    }
  }
}
li:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}
.price-won {
  display: flex;
  img {
    width: 12px;
    height: 12px;
    margin-right: 10px;
    line-height: 21px;
    padding-top: 3px;
  }
  .Thumb {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
}
.teacher {
  margin-top: 10px;
  display: flex;
  width: 40%;
  cursor: pointer;
  img {
    width: 22px;
    height: 22px;
    background: #999999;
    border-radius: 50%;
    margin-right: 9px;
  }
  span {
    text-align: left;
    line-height: 22px;
    // width: 40px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
}
.ranking {
  width: 92px;
  height: 109px;
  margin-left: 32px;
  margin-top: 21px;

  display: flex;
  flex-direction: column;
  img {
    width: 32px;
    height: 27px;
    margin-left: 60px;
    margin-bottom: 9px;
  }
  .el-button {
    padding: 0;
    margin: 0px;
  }
  .skkks {
    width: 32px;
    height: 27px;
    margin-left: 60px;
    margin-bottom: 9px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fd3333;
  }
}
.viewmore {
  width: 71px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  line-height: 21px;
}
.videss {
  width: 247px;
  height: 140px;
  margin-top: 5px;
  border-radius: 6px;
  margin-left: 10px;
}
button {
  background: #4ccaff;
  border: 0;
}
button:hover {
  background: #4ccaffc9;
}

// 适配手机端
@media (max-width: 768px) {
  .popularity {
    ul {
      min-height: 750px;
      margin-bottom: 40px;
      background: #ffffff;
      li {
        display: flex;
        width: 95vw;
        // height: 151px;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 6px;
        margin-bottom: 8px;
        transition: all 0.2s;
        .message {
          display: flex;
          flex-direction: column;
          padding: 18px 0 12px 19px;
          h4 {
            white-space: nowrap;
            display: flex;
            justify-content: left;
            width: 237px;
            // height: 14px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin-bottom: 4px;
            cursor: pointer;
          }
          p {
            cursor: pointer;
            width: 360px;
            height: 33px;
            font-size: 12px;
            font-family: "\5FAE\8F6F\96C5\9ED1";
            font-weight: 300;
            color: #999999;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 2; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
            margin-bottom: 9px;
          }
          .price {
            width: 360px;
            display: flex;
            justify-content: space-between;
            .price-now {
              width: 66px;
              text-align: left;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ff1616;
            }
          }
        }
      }
    }
  }
  li:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
  .price-won {
    display: flex;
    img {
      width: 12px;
      height: 12px;
      margin-right: 10px;
      line-height: 21px;
      padding-top: 3px;
    }
    .Thumb {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }
  }
  .teacher {
    margin-top: 10px;
    display: flex;
    width: 40%;
    cursor: pointer;
    img {
      width: 22px;
      height: 22px;
      background: #999999;
      border-radius: 50%;
      margin-right: 9px;
    }
    span {
      text-align: left;
      line-height: 22px;
      // width: 40px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
  }
  .ranking {
    width: 92px;
    height: 109px;
    margin-left: 32px;
    margin-top: 21px;

    display: flex;
    flex-direction: column;
    img {
      width: 32px;
      height: 27px;
      margin-left: 60px;
      margin-bottom: 9px;
    }
    .el-button {
      padding: 0;
      margin: 0px;
    }
    .skkks {
      width: 32px;
      height: 27px;
      margin-left: 60px;
      margin-bottom: 9px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #fd3333;
    }
  }
  .viewmore {
    width: 71px;
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    line-height: 21px;
  }
  .videss {
    width: 247px;
    height: 140px;
    margin-top: 5px;
    border-radius: 6px;
    margin-left: 10px;
  }
  button {
    background: #4ccaff;
    border: 0;
  }
  button:hover {
    background: #4ccaffc9;
  }
}
</style>
